// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__25GD8","question":"Question_question__gsSS8","description":"Question_description__2qC6c"};